/*@ngInject*/
const ProposalActionsRepository = function ($q, baseSharedPromiseRepository, currentSubmissionModel) {

    var sharedPromiseCache = {};

    angular.extend(this, baseSharedPromiseRepository);

    this.getGETSharedPromiseCache = function () {
        return sharedPromiseCache;
    };

    this.loadProposalActions = function (proposalId) {
        var url = '/rest/Actions?uri=com.firstbest.underwriting.proposal.Proposal:' + proposalId + '&registrationIdentifier=/Proposal/' + proposalId,
            cacheKey = 'proposalActions:' + proposalId;

        if (currentSubmissionModel.hasActionsRegistration('/Proposal/' + proposalId)) {
            return $q.resolve(null);
        } else {
            return this.get(cacheKey, url).then(function (responseData) {
                currentSubmissionModel.addActionsRegistration('/Proposal/' + proposalId, url);
                return responseData;
            });
        }
    };
};

angular.module('gw-um-submission')
    .service('proposalActionsRepository', ProposalActionsRepository);
